import { useQuery } from '@tanstack/react-query'

import { FetchIntakeFormStarterTemplate } from '@/services/IntakeFormService'

/**
 * The definition the new-form box opens pre-filled with.
 *
 * The box fixes its contents when it opens, so a definition arriving afterwards
 * has nowhere to go. Every refetch that could land mid-modal is therefore off,
 * and the value is held for the session rather than re-read per open: it is
 * deploy-scoped and identical for every organization, so a request whose answer
 * an open box would discard buys nothing. A starter changed by a deploy is
 * picked up on reload. A fetch that did not succeed is retried the next time the
 * box is opened, because a query holding no data is stale whatever the staleness
 * setting says.
 */
export const useIntakeFormStarterTemplate = () => {
  return useQuery({
    queryKey: ['intakeFormStarterTemplate'],
    queryFn: FetchIntakeFormStarterTemplate,
    // One attempt, bounded by the request timeout. The box cannot be typed into
    // until this settles, so a second attempt would double the shut-out; the
    // operator retries by closing the box and opening it again.
    retry: 0,
    staleTime: Infinity,
    // A query holding no data re-enters `pending` on every refetch, which would
    // put the modal back on its loading branch and tear down the open box.
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    // A missing pre-fill leaves the box usable, and the modal says so where the
    // box is — a toast on top would report a blocked state that this is not.
    meta: { suppressGlobalError: true },
  })
}
